module.exports = __webpack_public_path__ + "static/media/right-menu-promotion-icon.ce78ca22.svg";